export const RevenueConversionEvents = {
  CLICK_THROUGH: 'Click Through',
  ACTION_CONV: 'Action Conversion',
  // SUCCESS_URL: 'Success Url', // No longer displayed
  IMPRESSION: 'Impression',
};
